export default {
    data() {
        return {
            verificationTypes: {}
        }
    },
    created() {
        this.getVerificationTypeData();
    },
    methods: {
        async getVerificationTypeData() {
            this.isLoading = true;
            this.verificationTypes = await this.fetchVerificationTypes();
            this.isLoading = false;
        },
    }
}
